export default function downloaderFile(url, name) {
    fetch(url)
        .then(response => response.blob())
        .then(blob => {
            const blobUrl = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = blobUrl;
            link.setAttribute('download', name);
            // Detect Safari (excluding Chrome on iOS)
            const isSafari = /^((?!chrome|android).)*safari/i.test(navigator.userAgent);
            if (isSafari) {
                // Safari doesn't support download attribute for blobs
                window.open(blobUrl, '_blank');
            } else {
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }
            setTimeout(() => window.URL.revokeObjectURL(blobUrl), 1000);
        })
        .catch(() => {
            // Fallback: open the URL directly if fetch fails
            window.open(url, '_blank');
        });
}
